export default __webpack_public_path__ + "static/new-testosterone__core-360-paid-05-ec3f90ced1d4f1de6c4d324e19e0efbc.jpg";